import React, { useRef, useState } from 'react';
import './App.css';

// Firebase core
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Firebase Hooks
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

try{
  firebase.initializeApp({
    apiKey: "AIzaSyB8BwEBFXmgr7RSCjepdw2VEbryujtZZYg",
    authDomain: "votsep-27394.firebaseapp.com",
    projectId: "votsep-27394",
    storageBucket: "votsep-27394.appspot.com",
    messagingSenderId: "913372624311",
    appId: "1:913372624311:web:3a57b8162347f36f376432",
    measurementId: "G-MBYZZSZW40"
  });
} catch(exception) {

}

const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {
  const [user] = useAuthState(auth);
  return (
    <div className="App">
      <header>
        <h1>VOTSEP</h1>
        { auth.currentUser && <SignOut /> }
      </header>
      <section>
        {user ? <ChatRoom /> : <SignIn />}
      </section>
    </div>
  );
}

function SignIn() {

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }
  const signinWithGitHub = () => {
    const provider = new firebase.auth.GithubAuthProvider();
    auth.signInWithPopup(provider);
  }

  return (
    <>
      <button className="sign-in" onClick={signInWithGoogle}>Sign in with Google</button>
      <button className="sign-in" onClick={signinWithGitHub}>Sign in GitHub</button>
    </>
  )

}

function SignOut() {
  const {displayName, photoURL} = auth.currentUser;
  return (
    <>
      <div>
        <img src={photoURL} alt="profile" />
        <span className='username'>{displayName}</span>
      </div>
      <button className="sign-out" onClick={() => auth.signOut()}>Sign Out</button>
    </>
  )
}


function ChatRoom() {
  const messageCollection = firestore.collection('messages');
  const query = messageCollection.orderBy('createdAt').limit(25);
  const [chatlog] = useCollectionData(query, { idField: 'id' });

  const [message, setMessage] = useState('');
  const scroll = useRef();


  const sendMessage = async (e) => {
    e.preventDefault();
    const { uid, photoURL } = auth.currentUser;
    await messageCollection.add({
      uid,
      photoURL,
      message,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    })
    setMessage('');
    scroll.current.scrollIntoView({ behavior: 'smooth' });
  }

  return (
    <>
      <main>
        {chatlog && chatlog.map(msg => <ChatMessage key={msg.id} message={msg} />)}
        <span ref={scroll}></span>
      </main>
      <form onSubmit={sendMessage}>
        <input placeholder="taip yor mesej hiyar" value={message} onChange={(e) => setMessage(e.target.value)}/>
        <button type="submit" disabled={!message}><span>🍕</span></button>
      </form>
    </>
  )
}


function ChatMessage(props) {
  const { message, uid, photoURL } = props.message;
  const messageType = uid === auth.currentUser.uid ? 'sent' : 'received';
  // console.log(createdAt);
  return (<>
    <div className={`message ${messageType}`}>
      <img src={photoURL || 'https://avatars.dicebear.com/4.5/api/male/'+ uid +'.svg'} alt='avatar' />
      <p>{message}</p>
    </div>
  </>)
}

export default App;
